<script setup>
import { ref, computed, onMounted, defineAsyncComponent } from 'vue';
import { useRsvpStore } from '@/stores/rsvp/rsvp.store';
import formVersionList from '@/components/clients/rsvp/components/form/versions';
import { useStateStore } from '@/stores/state.store';

const stateStore = useStateStore();
const rsvpStore = useRsvpStore();

const mainColor = ref(rsvpStore.getColors.mainColor);
const backgroundColor = ref(rsvpStore.getColors.backgroundColor);

const weddingDate = computed(() => {
  const date = new Date(stateStore.getCommonData.eventDate);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const formattedDate = `${day}.${month}.${year}`;
  return formattedDate;
});

const FormChooserVersion = shallowRef(null);
const componentLoaded = ref(false);

function pickVersion() {
  if (formVersionList[rsvpStore.clientData.common.formVersion]) {
    FormChooserVersion.value = defineAsyncComponent(
      () =>
        import(
          `../components/form/versions/${
            formVersionList[rsvpStore.clientData.common.formVersion]
          }/FormChooser.vue`
        ),
    );
    componentLoaded.value = true;
  }
}

onMounted(() => {
  pickVersion();
});
</script>

<template>
  <div class="main-border">
    <div class="main">
      <div class="head">
        <h1 class="header">{{ rsvpStore.clientData.common.header }}</h1>
      </div>
      <div class="body">
        <img class="circuled" :src="rsvpStore.getImages.rsvp.url" alt="" />
      </div>
      <div class="text">
        <h2 class="core-default-h2">
          Serdecznie Zapraszamy na Nasze Wesele&nbsp;{{ weddingDate }}!
        </h2>
        <p>
          Z wielką radością chcielibyśmy, abyście byli częścią naszego
          wyjątkowego dnia.
        </p>
        <p>
          Prosimy o potwierdzenie obecności oraz wybranie preferencji
          dotyczących menu.
        </p>
        <p>
          Nie zapomnij dodać tytuł piosenki, która sprawi, że ten dzień będzie
          jeszcze bardziej niezapomniany!
        </p>
      </div>
      <FormChooserVersion v-if="componentLoaded" />
      <div class="foot core-default-h4">2025</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
p {
  margin: 0;
}

.main-border {
  background-attachment: fixed;
  position: relative;
  margin: auto;
  margin-bottom: 45px;
  max-width: 900px;
  width: 70%;

  @media screen and (max-width: 768px) {
    width: 90%;
  }

  .main {
    color: v-bind(mainColor);
    background: v-bind(backgroundColor);
    border-radius: 24px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;

    @media screen and (max-width: 500px) {
      gap: 10px;
    }

    .head {
      width: 100%;
      padding: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;

      @media screen and (max-width: 500px) {
        padding: 5px;
      }

      .header {
        font-size: 50px;
        line-height: normal;
        font-family: 'Petit Formal Script', serif;

        @media screen and (max-width: 500px) {
          font-size: 30px;
        }
      }

      .star {
        @media screen and (max-width: 500px) {
          width: 20px;
          height: 20px;
        }
      }
    }

    .body {
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      gap: 15px;

      .circuled {
        border-radius: 14px;
        margin: 0 1%;
      }
    }

    .text {
      text-align: center;
      width: 80%;
      margin: auto;
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      gap: 15px;

      @media screen and (max-width: 500px) {
        gap: 8px;
      }

      p {
        font-size: 20px;
        line-height: normal;
        font-family: 'MADE Mirage', serif;

        @media screen and (max-width: 500px) {
          font-size: 16px;
        }
      }
    }

    .foot {
      color: v-bind(mainColor);
      font-size: 27px;
      margin: 0 auto 10px;

      @media screen and (max-width: 500px) {
        font-size: 18px;
        line-height: 30px;
        margin: 0 auto 5px;
      }
    }
  }
}
</style>
